<template>
  <div ref="createModal" class="modal fade" id="modal-delete-link" tabindex="-1">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Отвязка магазина</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="col-12">
            <p class="center color-red">
              Вы действительно хотите отвязать магазин от компании?
            </p>
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-lg-6">
                    <h3 class="card-title">Магазин:</h3>
                    <p class="card-subtitle">
                      <template v-if="fields.shopName">
                        <img class="img-round" width="24" :src="fields.shopImage">
                        <span>{{ fields.shopName }}</span>
                      </template>
                      <template v-else>
                        Нет
                      </template>
                    </p>
                  </div>
                  <div class="col-lg-6">
                    <h3 class="card-title">Источник:</h3>
                    <p class="card-subtitle">
                      <template v-if="fields.sourceName">
                        <img class="img-round" width="24" :src="fields.sourceImage">
                        <span>{{ fields.sourceName }}</span>
                      </template>
                      <template v-else>
                        Нет
                      </template>
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <h3 class="card-title">Компания:</h3>
                    <p class="card-subtitle">
                      <template v-if="fields.campaignName">
                        <span>{{ fields.campaignName }}</span>
                      </template>
                      <template v-else>
                        Нет
                      </template>
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" data-bs-dismiss="modal" @click="hide">
            Закрыть
          </button>
          <button class="btn btn-danger ms-auto" @click="send">
            <IconUnlink/>
            Отвязать
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {reactive, ref, onMounted, defineComponent} from 'vue'
import IconUnlink from '@/assets/icons/IconUnlink'

export default defineComponent({
  name: "ConfirmDeleteLink",
  components: {
    IconUnlink,
  },
  setup(props, {emit}) {
    const createModal = ref(null)
    const fields = reactive(getFields())

    let bootModal = null

    function preShowModal() {
    }

    function showModal(event) {
      const button = event.relatedTarget
      const linkItem = JSON.parse(button.getAttribute('data-link-item'))
      
      console.log(linkItem)

      setFields(linkItem)
    }

    onMounted(() => {
      bootModal = new bootstrap.Modal(createModal.value, {
        backdrop: 'static',
        keyboard: false
      })

      createModal.value.addEventListener('click', function (e) {
        if (e.target === createModal.value) {
          const shouldClose = confirm("Закрыть окно?")
          if (shouldClose) {
            bootModal.hide();
          }
        }
      })

      createModal.value.addEventListener('shown.bs.modal', showModal);
      createModal.value.addEventListener('show.bs.modal', preShowModal);
    })

    function getFields() {
      return {
        shopId: 0,
        shopName: "",
        shopImage: "",
        campaignId: 0,
        campaignName: "",
        sourceId: 0,
        sourceName: "",
        sourceImage: "",
      }
    }

    function setFields(item) {
      fields.shopId = item["shop_id"] || 0
      fields.shopName = item["shop_name"] || ""
      fields.shopImage = item["shop_image"] || ""
      fields.campaignId = item["campaign_id"] || 0
      fields.campaignName = item["campaign_name"] || ""
      fields.sourceId = item["source_id"] || 0
      fields.sourceName = item["source_name"] || ""
      fields.sourceImage = item["source_image"] || ""
    }

    function hide() {
      bootModal.hide()
      setFields({
        shopId: 0,
        shopName: "",
        shopImage: "",
        campaignId: 0,
        campaignName: "",
        sourceId: 0,
        sourceName: "",
        sourceImage: "",
      })
    }

    function send() {
      emit("onDeleteLink", fields.shopId, fields.campaignId, fields.sourceId)
      bootModal.hide()
      setFields({
        shopId: 0,
        shopName: "",
        shopImage: "",
        campaignId: 0,
        campaignName: "",
        sourceId: 0,
        sourceName: "",
        sourceImage: "",
      })
    }

    return {
      createModal,
      fields,
      hide,
      send,
    }
  }
})
</script>

<style scoped src="./css/style.css" />
